import React, {FC, useState} from 'react';
import { useForm } from 'react-hook-form';
import Datepicker, { DateValueType } from 'react-tailwindcss-datepicker';
// custom
import FileUploadCard from '../../file/FileUploadCard';

export type EventFormData = {
    title: string,
    description: string,
    url: string,    
    status: string,
    startDate: string | Date | null;
    endDate: string | Date | null;
};

type IEventFormProps = {
    type: 'create' | 'update',
    defaultFormData: EventFormData,
    onSubmit: (data: EventFormData) => void
};


const EventForm: FC<IEventFormProps> = ({type, defaultFormData, onSubmit}) => {
    const { register, handleSubmit, setValue } = useForm<EventFormData>({defaultValues: defaultFormData});

    const [calendarDate, setCalendarDate] = useState < DateValueType > (null);

    // evt handlers
    // evt handlers
    const handleValueChange = (newValue : DateValueType) => {        
        setValue('startDate', newValue?.startDate??'');
        setValue('endDate', newValue?.endDate??'');
        setCalendarDate(newValue);
    };

    const onFormSubmit = (formData: EventFormData) => {
        // validation
        const isNotEmpty =  Object.values(formData).every(value => value !== undefined && value !== '');        
        if (!isNotEmpty || !formData.startDate || !formData.endDate) {
            return console.log('Error, empty fields!', formData);
        }
        // console.log('Form data is: ', formData);
        onSubmit(formData);
        
    };

    return <section
    className="w-full flex-wrap flex flex-row lg:flex-nowrap justify-space-between">
    <section
        id="form-section"
        className="grow mr-3 my-3 rounded-xl p-4 shadow-lg bg-white dark:bg-gray-900">
        <form 
            onSubmit={handleSubmit(onFormSubmit)}
            className="w-full flex flex-wrap mb-6">
            {/* First Row */}
            <div className="w-full px-3 mb-6 md:mb-0">
                <label
                    className="block uppercase tracking-wide text-gray-700 dark:text-teal-400 text-xs font-bold mb-2"
                    htmlFor="grid-first-name">
                    Event Title*
                </label>
                <input
                    {...register('title')}
                    className="appearance-none block w-full border-2 border-blue-200 dark:border-teal-700 bg-gray-200 text-gray-700 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="grid-first-name"
                    type="text"
                    placeholder="Power Ministry conference"/>
                <p className="hidden text-red-500 text-xs italic">Required</p>
            </div>
            {/* Second Row */}
            <div className="w-full px-3">
                <label
                    className="block uppercase tracking-wide text-gray-700 dark:text-teal-400 text-xs font-bold mb-2"
                    htmlFor="form-description">
                    Description*
                </label>
                <textarea
                    {...register('description')}
                    id="form-description"
                    rows={4}
                    cols={10}
                    className="appearance-none block w-full border-2 border-blue-200 dark:border-teal-700 bg-gray-200 text-gray-700 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    placeholder="Write your thoughts here..."/>
            </div>
            {/* Third Row */}
            <div className="w-full px-3 mb-6 md:mb-0">
                <label
                    className="block uppercase tracking-wide text-gray-700 dark:text-teal-400 text-xs font-bold mb-2"
                    htmlFor="grid-first-name">
                    Image URL*
                </label>
                <input
                    {...register('url')}
                    className="appearance-none block w-full border-2 border-blue-200 dark:border-teal-700 bg-gray-200 text-gray-700 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="grid-first-name"
                    type="text"                                
                    placeholder="https://www.powerministry.info/images/partners/powerministry.jpeg"/>

                <p className="hidden text-red-500 text-xs italic">Required</p>
            </div>
            {/* Fourth Row */}
            <div className="w-full md:w-1/3 px-3 mb-6">
                <label
                    className="block uppercase tracking-wide text-gray-700 dark:text-teal-400  text-xs font-bold mb-2"
                    htmlFor="grid-state">
                    Event Activation Status*
                </label>
                <div className="relative">
                    <select
                        {...register('status')}
                        className="block appearance-none w-full border-2 border-blue-200 dark:border-teal-700 bg-gray-200 border border-gray-200 text-gray-700  py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                        id="grid-state">
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                    </select>
                    <div
                        className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg
                            className="fill-current h-4 w-4"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"><path
                            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                    </div>
                </div>
            </div>
            {/* Fifth Row */}
            <div className="w-full px-3 mb-6 md:mb-0">
                <label
                    className="block uppercase tracking-wide text-gray-700 dark:text-teal-400 text-xs font-bold mb-2"
                    htmlFor="grid-first-name">
                    Select Start Date & End Date*
                </label>
                <Datepicker                                
                    inputClassName="border-2 border-blue-200 dark:border-teal-700"
                    value={calendarDate}
                    onChange={handleValueChange}
                    showShortcuts={true}/>
            </div>
            {/* Submit button */}
            <button
                type='submit'                            
                className="my-6 mx-3 bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-4 border-b-4 border-blue-700 hover:border-blue-500 rounded">
                {type === 'create' ? 'Create new Event' : 'Update Event'}
            </button>
            <button
                type='reset'
                className="my-6 mx-3 bg-gray-300 hover:bg-gray-400 text-gray-700 hover:text-white font-bold py-2 px-4 border-b-4 border-gray-500 hover:border-gray-700 rounded">
                Cancel
            </button>
        </form>
    </section>
    <FileUploadCard onSelect={(url : string) => setValue('url', url)}/>
</section>
};

export default EventForm;